export const fixingAmount = (value, fixedNumber = 2) => {
  const amount = value;
  if (amount === null || isNaN(Number(amount))) {
    return "-";
  }
  return Number(amount).toFixed(fixedNumber);
};

export const resolveCurrency = (value) => {
  if (!value || value === "") return "USD";

  const isNumeric =
    typeof value === "number" ||
    (!isNaN(value) && !isNaN(parseFloat(value)));

  return isNumeric ? "USD" : value;
};

export const getBaseCurrency = (row) => {
  let currency;

  if (row?.gateway === "CRYPTO") {
    currency = row?.content?.coin;
  } else if (row?.gateway === "UPI") {
    currency = "INR";
  } else if (row?.content?.coin) {
    currency = row?.content?.coin;
  } else if (row?.content?.currency) {
    currency = row?.content?.currency;
  } else if (row?.tradingAccountId?.currency) {
    currency = row?.tradingAccountId?.currency;
  } else {
    currency = row?.currency;
  }

  return resolveCurrency(currency);
};

export const getRowCurrency = (row) => resolveCurrency(row?.currency);
